import React from "react"
import AboutMe from "../Components/AboutMe";

function Contact() {
  return (
    <div>
      

        <AboutMe />
      
    </div>
  )
};

export default Contact;

